module.exports = __webpack_public_path__ + "static/media/sv.aa6f1519.svg";